import translating from './translate.json';

const fieldsEditMeetingDetails = [
  { label: 'תאריך', name: 'createdAt', format: 'date' },
  { label: 'סוג פגישה', name: 'category' },
  { label: 'מטפל', name: 'therapistName' }
];

let fieldsMeetingDetails = [...fieldsEditMeetingDetails];
fieldsMeetingDetails.shift();
fieldsMeetingDetails.push({
  label: 'תאריך עדכון',
  name: 'lastUpdated',
  format: 'date'
});

export { fieldsEditMeetingDetails, fieldsMeetingDetails };

export const fieldsMeetingMeasures = [
  { label: translating.fatPercentage, name: 'fatPct' },
  { label: translating.weight, name: 'whight' },
  { label: 'BMI', name: 'bmi' },
  { label: translating.pulse, name: 'heartBeatRate' },
  { label: translating.bloodPressure, name: 'bloodPressure' },
  { label: translating.flexibilityIndex, name: 'flexibilityIndex' },
  { label: translating.muscleMass, name: 'MuscleMass' },
  { label: translating.muscleStrength, name: 'muscleStrength' }
];

export const fieldsEditMeasures = [
  {
    label: translating.weight,
    name: 'whight',
    width: '80px',
    type: 'number',
    required: true
  },
  {
    label: translating.bloodPressureSys,
    name: 'bloodPressureSys',
    type: 'number',
    required: true
  },
  {
    label: translating.bloodPressureDys,
    name: 'bloodPressureDys',
    type: 'number',
    required: true
  },
  {
    label: translating.pulse,
    name: 'heartBeatRate',
    type: 'number',
    required: true
  },
  {
    label: translating.fatPercentage,
    name: 'fatPct',
    type: 'number',
    required: true
  },
  {
    label: translating.flexibilityIndex,
    name: 'flexibilityIndex',
    type: 'number',
    required: true
  },
  {
    label: translating.muscleMass,
    name: 'MuscleMass',
    type: 'number',
    required: true
  },
  {
    label: translating.muscleStrength,
    name: 'muscleStrength',
    type: 'number',
    required: true
  },
  {
    label: translating.meetingSummery,
    name: 'meetingSummery',
    type: 'textarea'
  }
];
